import { useQuery, useQueryClient } from 'react-query';
import * as api from '../../services/api';

const useHelpDeskCategories = ({ accountId, branchId, includeDeleted = false, onlyMyCategories = false }) => {
  const queryClient = useQueryClient();
  const queryKey = ['helpDeskCategories', accountId, branchId, includeDeleted, onlyMyCategories];

  const { data, isLoading } = useQuery(
    queryKey,
    () =>
      api.fetchHelpDeskCategoriesForBranches({ accountId, branchIds: [branchId], includeDeleted, onlyMyCategories }),
    { enabled: !!accountId && !!branchId }
  );

  const refetchCategories = () => queryClient.invalidateQueries(queryKey);

  return {
    categories: data?.data?.[branchId] ?? [],
    isLoading,
    refetchCategories
  };
};

export default useHelpDeskCategories;
